/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { LegacyCustomElementResponse as ApiLegacyCustomElementResponse } from '../models/api/legacy-custom-element-response';
import { StoryResponse as ApiStoryResponse } from '../models/api/story-response';
import { createLegacyCustomElement } from '../fn/legacy-custom-element/create-legacy-custom-element';
import { CreateLegacyCustomElement$Params } from '../fn/legacy-custom-element/create-legacy-custom-element';
import { createLegacyCustomElementStory } from '../fn/legacy-custom-element/create-legacy-custom-element-story';
import { CreateLegacyCustomElementStory$Params } from '../fn/legacy-custom-element/create-legacy-custom-element-story';
import { deleteLegacyCustomElement } from '../fn/legacy-custom-element/delete-legacy-custom-element';
import { DeleteLegacyCustomElement$Params } from '../fn/legacy-custom-element/delete-legacy-custom-element';
import { getLegacyCustomElement } from '../fn/legacy-custom-element/get-legacy-custom-element';
import { GetLegacyCustomElement$Params } from '../fn/legacy-custom-element/get-legacy-custom-element';
import { getLegacyCustomElementStory } from '../fn/legacy-custom-element/get-legacy-custom-element-story';
import { GetLegacyCustomElementStory$Params } from '../fn/legacy-custom-element/get-legacy-custom-element-story';
import { moveLegacyCustomElement } from '../fn/legacy-custom-element/move-legacy-custom-element';
import { MoveLegacyCustomElement$Params } from '../fn/legacy-custom-element/move-legacy-custom-element';
import { updateLegacyCustomElement } from '../fn/legacy-custom-element/update-legacy-custom-element';
import { UpdateLegacyCustomElement$Params } from '../fn/legacy-custom-element/update-legacy-custom-element';
import { updateLegacyCustomElementStory } from '../fn/legacy-custom-element/update-legacy-custom-element-story';
import { UpdateLegacyCustomElementStory$Params } from '../fn/legacy-custom-element/update-legacy-custom-element-story';

@Injectable({ providedIn: 'root' })
export class LegacyCustomElementService extends BaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createLegacyCustomElement()` */
  static readonly CreateLegacyCustomElementPath = '/v1/boards/{boardId}/legacy-custom-elements';

  /**
   * Create legacy custom element.
   *
   * Create legacy custom element
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createLegacyCustomElement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLegacyCustomElement$Response(
    params: CreateLegacyCustomElement$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiLegacyCustomElementResponse>> {
    return createLegacyCustomElement(this.http, this.rootUrl, params, context);
  }

  /**
   * Create legacy custom element.
   *
   * Create legacy custom element
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createLegacyCustomElement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLegacyCustomElement(
    params: CreateLegacyCustomElement$Params,
    context?: HttpContext
  ): Observable<ApiLegacyCustomElementResponse> {
    return this.createLegacyCustomElement$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiLegacyCustomElementResponse>): ApiLegacyCustomElementResponse => r.body)
    );
  }

  /** Path part for operation `getLegacyCustomElement()` */
  static readonly GetLegacyCustomElementPath = '/v1/boards/{boardId}/legacy-custom-elements/{id}';

  /**
   * Get legacy custom element by ID.
   *
   * Get a legacy custom element by its ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLegacyCustomElement()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLegacyCustomElement$Response(
    params: GetLegacyCustomElement$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiLegacyCustomElementResponse>> {
    return getLegacyCustomElement(this.http, this.rootUrl, params, context);
  }

  /**
   * Get legacy custom element by ID.
   *
   * Get a legacy custom element by its ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLegacyCustomElement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLegacyCustomElement(
    params: GetLegacyCustomElement$Params,
    context?: HttpContext
  ): Observable<ApiLegacyCustomElementResponse> {
    return this.getLegacyCustomElement$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiLegacyCustomElementResponse>): ApiLegacyCustomElementResponse => r.body)
    );
  }

  /** Path part for operation `deleteLegacyCustomElement()` */
  static readonly DeleteLegacyCustomElementPath = '/v1/boards/{boardId}/legacy-custom-elements/{id}';

  /**
   * Delete legacy custom element.
   *
   * Delete legacy custom element
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteLegacyCustomElement()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLegacyCustomElement$Response(
    params: DeleteLegacyCustomElement$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return deleteLegacyCustomElement(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete legacy custom element.
   *
   * Delete legacy custom element
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteLegacyCustomElement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLegacyCustomElement(params: DeleteLegacyCustomElement$Params, context?: HttpContext): Observable<string> {
    return this.deleteLegacyCustomElement$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `updateLegacyCustomElement()` */
  static readonly UpdateLegacyCustomElementPath = '/v1/boards/{boardId}/legacy-custom-elements/{id}';

  /**
   * Update legacy custom element.
   *
   * Update legacy custom element
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLegacyCustomElement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLegacyCustomElement$Response(
    params: UpdateLegacyCustomElement$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return updateLegacyCustomElement(this.http, this.rootUrl, params, context);
  }

  /**
   * Update legacy custom element.
   *
   * Update legacy custom element
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLegacyCustomElement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLegacyCustomElement(params: UpdateLegacyCustomElement$Params, context?: HttpContext): Observable<string> {
    return this.updateLegacyCustomElement$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `moveLegacyCustomElement()` */
  static readonly MoveLegacyCustomElementPath = '/v1/boards/{boardId}/legacy-custom-elements/{id}/move';

  /**
   * Move transition elements.
   *
   * Move transition elements to a new group
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `moveLegacyCustomElement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  moveLegacyCustomElement$Response(
    params: MoveLegacyCustomElement$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return moveLegacyCustomElement(this.http, this.rootUrl, params, context);
  }

  /**
   * Move transition elements.
   *
   * Move transition elements to a new group
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `moveLegacyCustomElement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  moveLegacyCustomElement(params: MoveLegacyCustomElement$Params, context?: HttpContext): Observable<string> {
    return this.moveLegacyCustomElement$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `getLegacyCustomElementStory()` */
  static readonly GetLegacyCustomElementStoryPath = '/v1/boards/{boardId}/legacy-custom-elements/{id}/story';

  /**
   * Get legacy custom element story.
   *
   * Get legacy custom element story
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLegacyCustomElementStory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLegacyCustomElementStory$Response(
    params: GetLegacyCustomElementStory$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiStoryResponse>> {
    return getLegacyCustomElementStory(this.http, this.rootUrl, params, context);
  }

  /**
   * Get legacy custom element story.
   *
   * Get legacy custom element story
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLegacyCustomElementStory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLegacyCustomElementStory(
    params: GetLegacyCustomElementStory$Params,
    context?: HttpContext
  ): Observable<ApiStoryResponse> {
    return this.getLegacyCustomElementStory$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiStoryResponse>): ApiStoryResponse => r.body)
    );
  }

  /** Path part for operation `createLegacyCustomElementStory()` */
  static readonly CreateLegacyCustomElementStoryPath = '/v1/boards/{boardId}/legacy-custom-elements/{id}/story';

  /**
   * Create legacy custom element story.
   *
   * Create legacy custom element story
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createLegacyCustomElementStory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLegacyCustomElementStory$Response(
    params: CreateLegacyCustomElementStory$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return createLegacyCustomElementStory(this.http, this.rootUrl, params, context);
  }

  /**
   * Create legacy custom element story.
   *
   * Create legacy custom element story
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createLegacyCustomElementStory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLegacyCustomElementStory(
    params: CreateLegacyCustomElementStory$Params,
    context?: HttpContext
  ): Observable<string> {
    return this.createLegacyCustomElementStory$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `updateLegacyCustomElementStory()` */
  static readonly UpdateLegacyCustomElementStoryPath = '/v1/boards/{boardId}/legacy-custom-elements/{id}/story';

  /**
   * Update legacy custom element story.
   *
   * Update legacy custom element story
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLegacyCustomElementStory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLegacyCustomElementStory$Response(
    params: UpdateLegacyCustomElementStory$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return updateLegacyCustomElementStory(this.http, this.rootUrl, params, context);
  }

  /**
   * Update legacy custom element story.
   *
   * Update legacy custom element story
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLegacyCustomElementStory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLegacyCustomElementStory(
    params: UpdateLegacyCustomElementStory$Params,
    context?: HttpContext
  ): Observable<string> {
    return this.updateLegacyCustomElementStory$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }
}
